import {flatten, trimEnd, trimStart} from 'lodash'
import {ensureList} from './typing'

type nullableString = string | null | undefined

export function urlPathJoin(...parts: nullableString[] | Array<nullableString[]>) {
  return ensureList(flatten(parts)).reduce(
    (acc, val) => `${trimEnd(`${acc}`, '/')}/${trimStart(`${val}`, '/')}`
  )
}

export function getAbsoluteUrl(...parts: string[]) {
  const {location} = window
  return urlPathJoin(`${location.protocol}//${location.host}`, ...parts)
}
